/**
 * @generated SignedSource<<c2ad178c2b3a1f379c3ebeb758bfc2eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TeamsConversationSelectQuery$variables = {
  name?: string | null;
  team?: string | null;
};
export type TeamsConversationSelectQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly office365: {
        readonly conversations: ReadonlyArray<{
          readonly id: string;
          readonly isUser: boolean;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type TeamsConversationSelectQuery = {
  response: TeamsConversationSelectQuery$data;
  variables: TeamsConversationSelectQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "team"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "name",
      "variableName": "name"
    },
    {
      "kind": "Variable",
      "name": "team",
      "variableName": "team"
    }
  ],
  "concreteType": "OfficeConversationNode",
  "kind": "LinkedField",
  "name": "conversations",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUser",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamsConversationSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TeamsConversationSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfficeUserNode",
                "kind": "LinkedField",
                "name": "office365",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f191f4eeee8c6aefa9271d3d0394bac0",
    "id": null,
    "metadata": {},
    "name": "TeamsConversationSelectQuery",
    "operationKind": "query",
    "text": "query TeamsConversationSelectQuery(\n  $team: String\n  $name: String\n) {\n  viewer {\n    integrations {\n      office365 {\n        conversations(team: $team, name: $name) {\n          id\n          name\n          isUser\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3093ca0917e7601c28395251185dc78c";

export default node;
